import React from 'react';

import { appMethod as app } from '@utils/app';
import util from '@utils/util';
import { transformPx2Rem, convertStyleData } from '@utils/tools';

import { RequestStatus } from 'src/common/request-status/RequestStatus';
import { LoadingBtn } from 'src/common/loading-btn/LoadingBtn';

import './FranchiseeListCustomComponent.less';

/**
 * type: "franchisee-list" 
 * 组件：多商家组件
 */

export default class FranchiseeListCustomComponent extends React.Component {
  
  constructor(props) {
    super(props);
    let compindex = props.index;
    let pageInstance = app.getAppCurrentPage();
    this.init(compindex, pageInstance);
  }

  init = (compindex, pageInstance) => {
    let _this = this;
    let customFeature = pageInstance.data.eles[compindex].customFeature;
    let locationInfo = app.globalData.locationInfo;
    
    // 设置当前组件param
    pageInstance.setData({
      ['eles[' + compindex + '].param']: {
        'id'             : customFeature['id'],
        'form'           : customFeature['form'], //TODO: AppShopService::FORM_APP_SHOP,
        'page'           : 1,
        'app_id'         : app.getAppId(),
        'sort_key'       : 'distance',
        'sort_direction' : 1,
      }
    });

    let param = {};
    let isClassify = false;
    if (app.getInvolvedFromRefreshObject(customFeature.id, 'new-classify')) {
      isClassify = true;
    }
    if (isClassify) {
      return;
    }

    param.form = "app_shop";
    if (this.withSortCompFlag(compindex, pageInstance)) { // 判断是否有绑定排序组件
      param.sort_key = "weight";
      param.sort_direction = 0;
    } else {
      param.sort_key = "distance";
      param.sort_direction = 1;
    }
    param.page_size = customFeature.loadingNum || 10;
    param.page = 1;
    if (customFeature.sourceType == 'industry' && customFeature.source && customFeature.source != 'none') {
      param.industry_type = customFeature.source;
    } else if (customFeature.sourceType == 'shop' && customFeature.source && customFeature.source != 'none') {
      param.idx_arr = {
        "idx": "category",
        "idx_value": customFeature.source
      };
    }

    if (locationInfo.latitude) {
      let newdata = {};
      newdata['eles[' + compindex + '].location_address'] = locationInfo.address;
      pageInstance.setData(newdata);

      param.latitude = locationInfo.latitude;
      param.longitude = locationInfo.longitude;
      _this.getFranchiseeList(compindex, param, pageInstance);
    } else {
      app.getLocation({
        type: 'gcj02',
        success: function (res) {
          let latitude = res.latitude,
            longitude = res.longitude;

          if (res.latitude) {
            pageInstance.requestNum++;
            app.sendRequest({
              hideLoading: true,
              url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
              data: {
                latitude: latitude,
                longitude: longitude
              },
              success: function (res) {
                let newdata = {};
                newdata['eles[' + compindex + '].location_address'] = res.data.formatted_addresses.recommend;
                pageInstance.setData(newdata);

                app.setLocationInfo({
                  latitude: latitude,
                  longitude: longitude,
                  address: res.data.formatted_addresses.recommend,
                  info: res.data
                });
              }
            });
            param.latitude = latitude;
            param.longitude = longitude;

            _this.getFranchiseeList(compindex, param, pageInstance);
          } else {
            let newdata = {};
            newdata['eles[' + compindex + '].location_address'] = '定位失败';
            pageInstance.setData(newdata);
          }
        },
        fail: function (res) {
          let newdata = {};
          if (res.errMsg === 'getLocation:fail auth deny' || res.errMsg === "getLocation:fail:auth denied") {
            newdata['eles[' + compindex + '].location_address'] = '已拒绝定位';
          } else {
            newdata['eles[' + compindex + '].location_address'] = '定位失败';
          }
          param.sort_key = 'weight';
          _this.getFranchiseeList(compindex, param, pageInstance);
          pageInstance.setData(newdata);
        }
      });
    }

    app.getNationList(compindex);
  }

  getFranchiseeList = (compindex, param, pageInstance) => {
    let _this = this;
    let newdata = {};
    newdata['eles[' + compindex + '].loading'] = true;
    newdata['eles[' + compindex + '].loadingFail'] = false;
    newdata['eles[' + compindex + '].franchisee_data'] = [];
    newdata['eles[' + compindex + '].is_more'] = 1;
    newdata['eles[' + compindex + '].curpage'] = 0;
    if (param['sort_key'] === 'distance' && !param['latitude']) { // 防止没没有经纬度报错
      param['sort_key'] = 'weight';
      param['sort_direction'] = 0;
    }
    newdata['eles[' + compindex + '].param'] = param;

    pageInstance.setData(newdata);

    app.sendRequest({
      hideLoading: true,
      url: '/index.php?r=AppShop/GetAppShopByPage',
      data: param,
      method: 'post',
      success: function (res) {
        for (let index in res.data) {
          let distance = res.data[index].distance;
          res.data[index].distance = util.formatDistance(distance);
        }

        _this.getMyAppShopList(compindex, pageInstance);

        let newdata = {};
        newdata['eles[' + compindex + '].franchisee_data'] = res.data;
        newdata['eles[' + compindex + '].is_more'] = res.is_more || 0;
        newdata['eles[' + compindex + '].curpage'] = 1;
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = false;

        pageInstance.setData(newdata);
      },
      fail: function () {
        let newdata = {};
        newdata['eles[' + compindex + '].loading'] = false;
        newdata['eles[' + compindex + '].loadingFail'] = true;
        pageInstance.setData(newdata);
      }
    });
  }

  getMyAppShopList = (compindex, pageInstance, reset) => {
    let that = this;
    app.sendRequest({
      url: '/index.php?r=AppShop/GetMyAppShopList',
      data: {
        parent_app_id: app.getAppId()
      },
      hideLoading: true,
      success: function (res) {
        let newdata = {};
        let oldList = pageInstance.data.eles[compindex].franchisee_data || [];
        let list = res.data;
        let listId = [];
        if (reset) {
          let l = 0;
          for (let i = 0; i < oldList.length; i++) {
            if (oldList[i].is_audit == 2) {
              l++;
            } else {
              break;
            }
          }
          oldList.splice(0, l);
        }
        for (let i = 0; i < list.length; i++) {
          if (list[i].is_audit == 2) {
            oldList.unshift(list[i]);
            listId.push(list[i].id);
          }
        }
        if (reset) {
          for (let i = 0; i < oldList.length; i++) {
            if (oldList[i].is_audit == 1 && listId.indexOf(oldList[i].id) > -1) {
              oldList.splice(i, 1);
            }
          }
        }
        newdata['eles[' + compindex + '].franchisee_data'] = oldList;

        pageInstance.setData(newdata)
      }
    });
  }

  tapFranchiseeLocation = (event) => {
    let _this        = this;
    let compindex       = event.currentTarget.dataset.compindex;
    let pageInstance = app.getAppCurrentPage();

    pageInstance.setData({
      ['eles[' + compindex + '].showNationList']: true
    });

    return; // TODO: 是否之后的代码需要去掉

    function success(res) {
      let name    = res.name || res.address || '';
      let lat     = res.latitude;
      let lng     = res.longitude;
      let newdata = {};
      let param   = pageInstance.data.eles[compindex].param;
      let requestData;

      newdata['eles[' + compindex + '].location_address'] = name;
      pageInstance.setData(newdata);

      param.latitude = lat;
      param.longitude = lng;

      requestData = {
        id: compindex,
        form: 'app_shop',
        page: 1,
        sort_key: param.sort_key,
        sort_direction: param.sort_direction,
        latitude: param.latitude,
        longitude: param.longitude,
        idx_arr: param.idx_arr
      };
      app.globalData.locationInfo.latitude = lat;
      app.globalData.locationInfo.longitude = lng;

      this._refreshFranchiseeList(compindex, requestData, pageInstance);

      app.sendRequest({
        url: '/index.php?r=Map/GetAreaInfoByLatAndLng',
        data: {
          latitude: lat,
          longitude: lng
        },
        success: function (data) {

          if(!name || name == ' '){
            let newdata = {};
            newdata['eles[' + compindex + '].location_address'] = data.data.formatted_addresses.recommend;
            pageInstance.setData(newdata);
          }

          app.setLocationInfo({
            latitude: lat,
            longitude: lng,
            address: name,
            info: data.data
          });
        }
      });
    }

    function cancel() {
      console.log('cancel');
    }

    function fail() {
      console.log('fail');
    }
    app.chooseLocation({
      success: success,
      fail: fail,
      cancel: cancel
    });
  }

  turnToFranchiseeDetail = (event) => {
    let dataset = event.currentTarget.dataset;
    let appid = dataset.appid;
    let mode = dataset.mode;
    let pageLink = dataset.newpage;
    let param = {};

    param.detail = appid;
    if (dataset.audit == 2){
      param.shop_id = dataset.id;
    }
    if (pageLink){
      mode = dataset.newmode;
      this.turnToFranchiseePage(mode, pageLink, appid, param);
      return;
    }
    app.goToFranchisee(mode, param);
  }

  turnToFranchiseePage = (mode, pageLink, franchiseeId, param) =>{
    switch (pageLink.trim()) {
      case 'franchiseeWaimai':
        app.goToFranchisee(1, param);
        return;
      case 'franchiseeTostore':
        app.goToFranchisee(3, param);
        return;
      case 'franchiseeDetail4':
        app.goToFranchisee(2, param);
        return;
      case 'franchiseeDetail':
        app.goToFranchisee(0, param);
        return;
      default:
        break;
    }
    let queryStr = franchiseeId ? '?franchisee=' + franchiseeId + '&fmode=' + mode : '';
    app.turnToPage(pageLink + queryStr);
  }

  hideNationList = (event) => {
    let _this = this;
    let compindex = event.currentTarget.dataset.compindex;
    let pageInstance = app.getAppCurrentPage();

    pageInstance.setData({
      ['eles[' + compindex + '].showNationList']: false
    });
  }

  reLocalAddress = (event) => {
    let dataset = event.currentTarget.dataset,
      pageInstance = app.getAppCurrentPage();
    let compindex = dataset.compindex;
    let param = pageInstance.data.eles[compindex].param;
    let newdata = {};
    newdata['eles[' + compindex + '].showNationList'] = false;
    pageInstance.setData(newdata);
    if (dataset.nationid) {
      app.turnToPage('searchAddress?from=franchisee&locateAddress=' + dataset.address + '&compindex=' + dataset.compindex + '&nationId=' + dataset.nationid + '&nationname=' + dataset.nationname + '&latitude=' + param.latitude + '&longitude=' + param.longitude);
    }
  }

  franchiseeListRefresh = (event) => {
    let compindex       = event.currentTarget.dataset.compindex;
    let pageInstance = app.getAppCurrentPage();
    let param = pageInstance.data.eles[compindex].param; // 就是当前组件的param
    let requestData = {};

    requestData = {
      id: compindex,
      form: 'app_shop',
      page: 1,
      sort_key: param.sort_key,
      sort_direction: param.sort_direction,
      latitude: param.latitude,
      longitude: param.longitude,
      idx_arr: param.idx_arr
    };

    this._refreshFranchiseeList(compindex, requestData, pageInstance);
  }

  withSortCompFlag = (compindex, pageInstance) => {
    let pageData = pageInstance.data;
    let targetId = pageData.eles[compindex].customFeature.id;
    return pageData.eles.some((ele) => !ele.hidden && ele.customFeature.sort_object === targetId)
  }

  _refreshFranchiseeList = (targetCompIndex, requestData, pageInstance) => {
    let _this = this;
    let newdata = {};
    newdata['eles[' + targetCompIndex + '].loading'] = true;
    newdata['eles[' + targetCompIndex + '].loadingFail'] = false;
    newdata['eles[' + targetCompIndex + '].franchisee_data'] = [];
    newdata['eles[' + targetCompIndex + '].is_more'] = 1;
    newdata['eles[' + targetCompIndex + '].curpage'] = 0;
    newdata['eles[' + targetCompIndex + '].param'] = requestData;
    pageInstance.setData(newdata);

    requestData.latitude = app.globalData.locationInfo.latitude;
    requestData.longitude = app.globalData.locationInfo.longitude;

    app.sendRequest({
      url: '/index.php?r=AppShop/GetAppShopByPage',
      method: 'post',
      data: requestData,
      success: function (res) {
        let newData = {};

        for (let index in res.data) {
          let distance = res.data[index].distance;
          res.data[index].distance = util.formatDistance(distance);
        }
        newData['eles[' + targetCompIndex + '].franchisee_data'] = res.data;
        newData['eles[' + targetCompIndex + '].is_more'] = res.is_more;
        newData['eles[' + targetCompIndex + '].curpage'] = 1;
        newData['eles[' + targetCompIndex + '].scrollTop'] = 0;
        newData['eles[' + targetCompIndex + '].loadingFail'] = false;
        newData['eles[' + targetCompIndex + '].loading'] = false;
        pageInstance.setData(newData);
      },
      fail: function (res) {
        let newdata = {};
        newdata['eles[' + targetCompIndex + '].loadingFail'] = true;
        newdata['eles[' + targetCompIndex + '].loading'] = false;
        pageInstance.setData(newdata);
      }
    })
  }

  franchiseeScrollFunc = (event) => {
    // TODO 未处理滚动加载
    console.log('TODO: 未处理滚动加载')
    return;
    app.franchiseeScrollFunc(event)
  }

  render() {
    // 组件数据
		const data = this.props.data;
    // 组件配置对象
    const customFeature = data.customFeature;
    const style = convertStyleData(data.style);
    if (customFeature.vesselAutoheight == 0) {
      style['height'] = transformPx2Rem(customFeature['height'], 320);
    }
		const imgStyle = {
			width: transformPx2Rem(customFeature.imgWidth,320),
			height: transformPx2Rem(customFeature.imgHeight,320),
    };
    const itemStyle = {
      backgroundColor: customFeature.lineBackgroundColor,
      backgroundImage: customFeature.lineBackgroundImage,
      marginBottom: transformPx2Rem(customFeature.margin),
    }

    return (
      <div className="custom-component franchisee-list" style={style}>
        <div className="franchisee-title" onClick={this.tapFranchiseeLocation} data-compindex={this.props.index}>
          <div className="location"
            onClick={this.tapFranchiseeLocation}
            data-compindex={this.props.index}
            >
            <span className="ico-moon icon-fre_adress">{data.location_address || '定位中...'}</span>
          </div>
          附近商家
        </div>
        <div className="list-wrap" onScroll={this.franchiseeScrollFunc}>
          {
            data.franchisee_data && data.franchisee_data.map((item,index) =>
            <div className="list-item" key={index} style={itemStyle}
              onClick={this.turnToFranchiseeDetail}
              data-appid={item.app_id}
              data-mode={item.mode_id}
              data-audit={item.is_audit}
              data-id={item.id}
              data-newpage={item.sub_app_bar['homepage-router'] || ''}
              data-newmode={item.sub_app_bar.mode_id || ''}
              >
              <div className="img-wrap" style={imgStyle}>
                <img src={item.picture} alt=""/>
                {
                  item.open_staus == 0 &&
                  <div className="not-open-mask">
                    <div className="list-status not-open-tip">休息中</div>
                  </div>
                }
                {
                  item.is_audit == 2 &&
                  <div className="list-status list-audit">待审核</div>
                }
              </div>
              <div className="info-wrap">
                <div className="title-wrap">
                  <div className="title">{item.name}</div>
                  {
                    !!item.distance &&
                    <div className="distance">{item.distance}</div>
                  }
                </div>
                {
                  !!item.per_capita &&
                  <div className="defaul">
                    <div className="average-price">¥{item.per_capita}/人</div>
                  </div>
                }
                {
                  item.industry_type_name && 
                  <div className="list-bottom">
                    <div className="list-industry">{item.industry_type_name}</div>
                  </div>
                }
                {
                  item.coupon_list.best_subtract_value || item.coupon_list.best_discount &&
                  <div className="discount-coupons">
                    {
                      item.coupon_list.best_subtract_value !='' &&
                      <div className="coupons-cash">
                        <span>减</span>
                        进店领取{item.coupon_list.best_subtract_value}
                      </div>
                    }
                    {
                      item.coupon_list.best_discount != '' &&
                      <div className="coupons-rebate">
                        <span>折</span>
                        进店领取{item.coupon_list.best_discount}折优惠
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            )
          }
          {/* 加载loading */}
          {
            data.loading && 
            <RequestStatus is="requestLoading"></RequestStatus>
          }
          {/* 加载没有数据 */}
          {
            data.is_more == 0 && data.franchisee_data && data.franchisee_data.length == 0 &&
            <RequestStatus is="requestNone" data={{ data: '暂无商家~'}}></RequestStatus>
          }
          {/* 加载失败 */}
          {
            data.loadingFail &&
            <RequestStatus is="requestFail" data={{refreshEvent: 'franchiseeScrollFunc', compindex: this.props.index}}></RequestStatus>
          }
          {/* 加载完所有数据 */}
          {
            data.is_more == 0 && data.franchisee_data && data.franchisee_data.length > 0 && data.customFeature.isShowFinishText &&
            <RequestStatus is="requestAll"></RequestStatus>
          }
          {/* 点击加载按钮 */}
          {
            data.customFeature.vesselAutoheight == 1 && data.customFeature.loadingMethod == 1 && data.customFeature.mode != 2 && !!data.is_more && data.is_more != 0 && !data.loading && !data.loadingFail &&
            <LoadingBtn customFeature={customFeature} onClick={this.franchiseeScrollFunc} data-compindex={this.props.index}></LoadingBtn>
          }
        </div>
        {
          data.showNationList &&
          <div className='nation-select-container'>
            <div className="nation-list-wrap">
              <div className='nation-closed' onClick={this.hideNationList} data-compindex={this.props.index}>
                <span className='ico-moon icon-closed'></span>
              </div>
              <div className="tip">
                选择服务所在国家
              </div>
              <div className="list">
                {
                  data.nationList && data.nationList.map((item, itemIndex) => (
                    <div key={itemIndex}
                      onClick={this.reLocalAddress}
                      data-nationname={item.nation_name}
                      data-nationid={item.oversea_region_id}
                      data-compindex={this.props.index}
                      data-address={data.location_address}
                      data-latlng={data.addressInfo}>
                      <div className="nation-name">
                        {item.nation_name}
                      </div>
                      <div className='ico-moon icon-rightarrow'></div>
                    </div>
                  ))
                }
              </div>
            </div>
          </div>
        }
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/custom-component/franchisee-list-custom-component/FranchiseeListCustomComponent.jsx